import { useNavigate } from 'react-router-dom'

const BuildTrust = () => {
  const navigate = useNavigate()
  return (
    <div
      className='mt-20 lg:mt-[100px] 2xl:mt-[150px] 3xl:mt-[200px] flex flex-col justify-center items-center box-border px-[20px] py-[140px] gap-10 self-stretch lg:px-[80px] 
    lg:py-[140px] lg:gap-10 2xl:px-[120px] 2xl:py-[200px] 2xl:gap-15 3xl:px-[200px] 3xl:py-[300px] 3xl:gap-15 bg-[#EBFBFF]'
    >
      <h2 className='text-[#001A3D] text-center font-bold tracking-wide text-lg leading-6 lg:text-2xl lg:leading-8 3xl:text-[40px] 3xl:leading-normal'>
        Built for trust. Driven by our data. Designed around you.
      </h2>

      <button
        className='appearance-none focus:outline-none flex justify-center items-center gap-[10px] bg-[#020251] text-white shadow-[0_1px_4px_rgba(0,0,0,0.25)] 
        text-center  font-medium tracking-wide h-[24px] px-[8px] py-[4px] rounded-sm text-xs leading-4 2xl:h-[44px] 2xl:px-[16px] 2xl:py-[12px] 2xl:rounded-lg 
        2xl:text-base 2xl:leading-5 '
        onClick={() => navigate('/ourstory')}
      >
        Our story
      </button>
    </div>
  )
}
export default BuildTrust
